export default __webpack_public_path__ + "static/media/mirolyub_s.cc119d2e.jpg";